export default __webpack_public_path__ + "static/es-6f351f66e19f92abe903a2ac817648f1.svg";